module.exports = __webpack_public_path__ + "static/img/back.c571098c.svg";